import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../config/apiHandle.js";
import { type_constant } from "../utils/asyncStatus.js";

export const getAllCustomers = createAsyncThunk(
  type_constant.GET_ALL_Customers_ASYNC,
  async () => {
    try {
      const response = await apiHandle.get(`admin/get-my-customers`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);


export const updateCustomerStatus = createAsyncThunk(
  type_constant.UPDATE_Customer_STATUS_ASYNC,
  async ({ id, status = null }) => {
    try {
      const response = await apiHandle.patch(
        `admin/update-customer/${id}`,
        { status }
      );
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);


export const updateCustomerTags = createAsyncThunk(
  type_constant.UPDATE_Customer_TAGS_ASYNC,
  async ({ id, tags = null }) => {
    try {
      const response = await apiHandle.patch(
        `admin/update-customer/${id}`,
        { tags }
      );
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);